import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Service } from 'src/app/shared/models/service';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class ServiceService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllService(): Observable<Service[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.serviceUrl}/all`,
			'getAllService'
		);
	}

	getServicesByUser(userId: number): Observable<Service[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.serviceUrl}/getByUserId/${userId}`,
			'getServicesByUser'
		);
	}

	getServicesByTypeHandicap(typeHandicapId: number): Observable<Service[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.serviceUrl}/getByTypeHandicap/${typeHandicapId}`,
			'getServicesByTypeHandicap'
		);
	}

	importService(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'service.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.serviceUrl}/import`,
			`importService`,
			formData
		);
	}

	getServiceById(id: number): Observable<Service> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.serviceUrl}/get/${id}`,
			'getServiceById'
		);
	}

	updateService(service: Service): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.serviceUrl}/update/${service.id}`,
			'updateService',
			service
		);
	}

	addService(service: Service): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.serviceUrl}/add`,
			'addService',
			service
		);
	}

	deleteService(serviceId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.serviceUrl}/delete/${serviceId}`,
			`deleteService`
		);
	}
}
